<template>
  <baseEdit :canEdit="false" :disabledBusinessType="true" />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'claimCK',
    components: {
      baseEdit,
    },
  };
</script>
